<template>
  <div style="display: inline-block">
    <!-- <el-date-picker
      v-model="date"
      style="width: 150px"
      format="yyyy年M月"
      value-format="yyyy-MM"
      @change="handleSelectInputClick"
      type="month"
      placeholder="选择月"
    >
    </el-date-picker> -->
    <el-date-picker
      v-model="date"
      style="width: 300px"
      type="monthrange"
      range-separator="至"
      start-placeholder="开始月份"
      end-placeholder="结束月份"
      @change="handleSelectInputClick"
      :picker-options="pickerOptions"
    >
    </el-date-picker>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'reportMonthCopy',
  props: {
    handleSelectInput: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      date: this.GLOBAL.date ? [this.GLOBAL.date, this.GLOBAL.date] : [new Date(),new Date()],
      minDate: null,
      maxDate: null,
      pickerOptions: {
        disabledDate: (time) => {
          if (this.minDate !== null && this.maxDate === null) {
            let minMonth = this.minDate.getMonth(),
              lastYear = new Date(this.minDate).setMonth(minMonth - 5),
              nextYear = new Date(this.minDate).setMonth(minMonth + 5)
            // 只能选 minDate 前后一年的范围
            return time.valueOf() < lastYear.valueOf() || time.valueOf() > nextYear.valueOf()
          }
          return false
        },
        onPick: ({ minDate, maxDate }) => {
          this.minDate = minDate
          this.maxDate = maxDate
        },
      },
    }
  },
  created() {
    this.handleSelectInputClick()
    debugger
  },
  methods: {
    handleSelectInputClick() {
      debugger
      let month = moment(this.date[0]).format('YYYY-MM')
      let endmonth = moment(this.date[1]).format('YYYY-MM')
      if (this.date) {
        this.GLOBAL.date = moment(this.date[0]).format('YYYY-MM')
        this.handleSelectInput(this.date)
      } else {
        this.GLOBAL.date = ''
      }
    },
  },
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/statement/components/reportMonthCopy.vue